import React, {useEffect, useState} from 'react';
import {getHeaderNotification,  getFaqsData} from './../utils/endpoints'
import HeaderNotification from './components/headerNotification';
import Loading from './components/loading';
import Header from './components/header';
import Footer from './components/footer';
import { Container} from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import file01 from '../assets/pdf/notice-of-candidature-of-a-person-for-directorship/2015.08.01-Notice-of-Candidature-for-apppointment-of-Director-to-Mr-Sanjay-Daya.pdf'
import file02 from '../assets/pdf/notice-of-candidature-of-a-person-for-directorship/2017.08.26-Notice-of-Candidature-for-apppointment-of-Director-to-Mr-Krishna-Nowal.pdf'


const NoticeOfCandidature = () => {
  const [headerNotificationData, setheaderNotificationData] = useState(null);
  const [faqs, setFaqs] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const faqs = await getFaqsData();
        const headerNotificationData = await getHeaderNotification();
        setheaderNotificationData(headerNotificationData);
        setFaqs(faqs);
        
        setIsLoading(false);
      } catch (error) {
        setError(error);
        setIsLoading(false);
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const faQSlice = faqs;

  if (isLoading) {
    return <div><Loading /></div>;
  }

  if (error) {
    return (
    <div className='error_modal'>
      <div className='error_modal-wrapper'>
        <img  src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Statue of Belief"/>
        <h1>We’re making a few improvements to serve you better. Please check back shortly for an enhanced experience.</h1>
        <button class="reload-btn" onClick={() => window.location.reload()}>
            Reload Page
        </button>
      </div>
    </div>
    );
  }

  return (
    <div>
      <Helmet>
      <title>Notice of Candidature of a Person for Directorship | Investors | Statue of Belief</title>
      </Helmet>
      <HeaderNotification compData={headerNotificationData}/>
      <Header />
      <section className='section-breadcrumb'>
      <Container>
      <ul>
            <li><a href="/">Home</a></li>
            <li>Notice of Candidature of a Person for Directorship</li>
        </ul>
        <h1>Notice of Candidature of a Person for Directorship</h1>
      </Container>
    </section>
    <section className='section-about'>
    <Container>
      <h2 class="mb-3">Notice of Candidature of a Person for Directorship</h2>
        <ul className='list-item'>
            <li><a href={file01} download>2015.08.01 Notice of Candidature for apppointment of Director to Mr Sanjay Daya</a></li>
            <li><a href={file02} download>2017.08.26 Notice of Candidature for apppointment of Director to Mr Krishna Nowal</a></li>
        </ul>
    </Container>
    </section>
    <Footer />
    </div>
  );
};

export default NoticeOfCandidature;